export const getStarProps = (index = 0, star = 0) => {
  const currentStar = index + 1;

  return {
    full: star >= currentStar,
    half: (star - index) * 10 === 5,
  };
};
